import type { ReactNode } from 'react';
import type { Recipient, Status } from './OutreachDialog.tsx';

import { faBell } from '@fortawesome/pro-regular-svg-icons';

import {
  Content,
  DeliverySummary,
  Footer,
  Header,
  MessagePreview,
  RecipientDetails,
  RecipientList,
  Root,
} from './OutreachDialog.tsx';

export function RequestConfirmationDialog(props: {
  onClose: () => void;
  onConfirm: () => void;
  // 'error' keeps the dialog open (dismiss still works) but blocks confirming — e.g. the
  // single-send preview failed, so there is no vetted copy to send.
  status: Status;
  title: string;
  // ReactNode (not string) so the single-send flow can show a skeleton while Mia's real copy
  // is being generated server-side.
  message: ReactNode;
  // The channel(s) the send goes out on, rendered after "Sent via". ReactNode so the single-send
  // flow can show an inline skeleton until the preview reveals the resolved channel.
  channelLabel: ReactNode;
  confirmLabel: string;
  recipients: Recipient[];
}) {
  if (props.recipients.length > 1) {
    return (
      <Root onClose={props.onClose}>
        <Header color="error" icon={faBell}>
          {props.title}
        </Header>

        <Content>
          <MessagePreview label="Message Template">{props.message}</MessagePreview>

          <RecipientList
            note="Bracketed details will be personalized for each recipient"
            recipients={props.recipients}
          />

          <DeliverySummary>
            Sent via {props.channelLabel} · {props.recipients.length} patients will be prompted to
            confirm
          </DeliverySummary>
        </Content>

        <Footer
          color="error"
          confirmLabel={props.confirmLabel}
          icon={faBell}
          onConfirm={props.onConfirm}
          status={props.status}
        />
      </Root>
    );
  }

  return (
    <Root onClose={props.onClose}>
      <Header color="error" icon={faBell}>
        {props.title}
      </Header>

      <Content>
        {props.recipients[0] ? <RecipientDetails recipient={props.recipients[0]} /> : null}

        <MessagePreview label="Message">{props.message}</MessagePreview>

        <DeliverySummary>
          Sent via {props.channelLabel} · Patient will be prompted to confirm
        </DeliverySummary>
      </Content>

      <Footer
        color="error"
        confirmLabel={props.confirmLabel}
        icon={faBell}
        onConfirm={props.onConfirm}
        status={props.status}
      />
    </Root>
  );
}
